module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/BuyReasonSection/customer-support-5851d8344f6a6d61968dd543a16b6d7f.png";